import styled from 'styled-components';

export default styled.div`
	.motif-text-area{
		height:auto;
	}
`;
